import { useEffect, useState } from 'react';
import useIsMobile from './use-is-mobile';

/** 初始化时m端、pc端的元素都渲染，通过css控制显隐，初始化完成后移除不显示的组件 */
const useIsMobileSsr = () => {
  const [isInit, setIsInit] = useState(true);
  const isMobile = useIsMobile();

  useEffect(() => {
    setIsInit(false);
  }, []);

  return {
    isMobile: isInit || isMobile,
    isDesktop: isInit || !isMobile,
  };
};

export { useIsMobileSsr };
